
/**
 * @description - Computes the map subscriptin discount
 * @param {Array<String>} regions - The regions selected by the user
 * @param {Object} city_plan - the map_city plan
 * @param {Object} state_plan - the map_state plan
 * @return {Number} - The amount that will be discounted from the maps total
 */
const computeDiscount = (regions, map_city_plan, map_state_plan) => {
  const maps_discount = regions
  .sort((r1, r2) => /^\/Plans\/State/.test(r1) ? -1 : 1)
  .reduce((acc, region, idx) => {
    if(idx == 0) {
      return 0;
    }
    else if(/^\/Plans\/State/.test(region)) {
      return acc + (+map_state_plan.amount * 0.40);
    }
    else {
      return acc + (+map_city_plan.amount * 0.40);
    }
  }, 0);

  return maps_discount;
}

module.exports = computeDiscount;



// WEBPACK FOOTER //
// ./src/browser/components/settings/subscriptions/utils/computeDiscount.js